// context/FormContext.tsx
import React, { createContext, useContext, useState } from 'react';

interface FormContextType {
  form: Form | null;
  setForm: (form: Form | null) => void;
}

const FormContext = createContext<FormContextType | undefined>(undefined);

export const FormProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [form, setForm] = useState<Form | null>(null);

  return (
    <FormContext.Provider value={{ form, setForm }}>
      {children}
    </FormContext.Provider>
  );
};

export const useForm = (): FormContextType => {
  const context = useContext(FormContext);
  if (!context) throw new Error('useForm deve estar dentro do FormProvider');
  return context;
};
